// src/services/authService.js
import axios from "axios";
import API_URL from "../config";
import { getAccessToken } from "../utils/tokenManager";

const http = axios.create({ baseURL: API_URL });

http.interceptors.request.use((config) => {
  const token = getAccessToken();

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers?.Authorization) {
    delete config.headers.Authorization;
  }

  return config;
});

const authService = {
  login: async ({ email, password, role = "u" }) => {
    const res = await http.post(`/auth/login/${role}`, { email, password });
    return res.data.data; // ApiResponse
  },
  register: async ({ name, surname, email, role }) => {
    const res = await http.post(`/auth/register`, { name, surname, email, role });
    return res.data.data;
  },

  me: async () => {
    const res = await http.get(`/auth/me`);
    return res.data.data;
  },

  refresh: async (refreshToken) => {
    const res = await http.post(`/auth/refresh`, { refreshToken });
    return res.data; // ApiResponse
  },
};

export default authService;
